module.exports = __webpack_public_path__ + "img/炙红芪.24590d27.jpg";